import {
  MIDI_DEAL_PRODUCTS_REQUEST,
  MIDI_DEAL_PRODUCTS_SUCCESS,
  MIDI_DEAL_PRODUCTS_FAIL,
  MIDI_DEAL_EVENT_REQUEST,
  MIDI_DEAL_EVENT_SUCCESS,
  MIDI_DEAL_EVENT_FAIL,
  MIDI_DEAL_ELIGIBILITY_REQUEST,
  MIDI_DEAL_ELIGIBILITY_SUCCESS,
  MIDI_DEAL_ELIGIBILITY_FAIL,
  MIDI_DEAL_STATUS_REQUEST,
  MIDI_DEAL_STATUS_SUCCESS,
  MIDI_DEAL_STATUS_FAIL,
} from '../constants/midiDealConstants';

export const midiDealReducer = (state = {}, action) => {
  switch (action.type) {
    case MIDI_DEAL_PRODUCTS_REQUEST:
      return { ...state, loading: true };
    case MIDI_DEAL_PRODUCTS_SUCCESS:
      return { ...state, loading: false, products: action?.payload, lastFetchedAt: Date.now(), lastStoreId: action?.storeId };
    case MIDI_DEAL_PRODUCTS_FAIL:
      return { loading: false, error: action.payload };
    case MIDI_DEAL_EVENT_REQUEST:
      return { ...state, eventLogging: true, eventError: null };
    case MIDI_DEAL_EVENT_SUCCESS:
      return { ...state, eventLogging: false, eventError: null };
    case MIDI_DEAL_EVENT_FAIL:
      return { ...state, eventLogging: false, eventError: action.payload };
      return { ...state, loading: false, error: action?.payload };
    case MIDI_DEAL_ELIGIBILITY_REQUEST:
      return { ...state, eligibilityLoading: true, eligibility: null };
    case MIDI_DEAL_ELIGIBILITY_SUCCESS:
      return {
        ...state,
        eligibilityLoading: false,
        eligibility: action?.payload,
      };
    case MIDI_DEAL_ELIGIBILITY_FAIL:
      return {
        ...state,
        eligibilityLoading: false,
        eligibilityError: action?.payload,
      };
    case MIDI_DEAL_STATUS_REQUEST:
      return { ...state, statusLoading: true };
    case MIDI_DEAL_STATUS_SUCCESS:
      return { ...state, statusLoading: false, isActive: action?.payload?.isActive ?? false };
    case MIDI_DEAL_STATUS_FAIL:
      return { ...state, statusLoading: false, isActive: false };
    default:
      return state;
  }
};
